/**
 * @generated SignedSource<<092df9eab5b538f8956d5866c2ba1e58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ScreenerSurveyQuery$variables = {};
export type ScreenerSurveyQuery$data = {
  readonly signupSurveyUrl: string | null;
};
export type ScreenerSurveyQuery = {
  variables: ScreenerSurveyQuery$variables;
  response: ScreenerSurveyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signupSurveyUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScreenerSurveyQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ScreenerSurveyQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "df084c33eac94fec2a23b64935f964b6",
    "id": null,
    "metadata": {},
    "name": "ScreenerSurveyQuery",
    "operationKind": "query",
    "text": "query ScreenerSurveyQuery {\n  signupSurveyUrl\n}\n"
  }
};
})();

(node as any).hash = "3a8309051080cbea9268e9f281781942";

export default node;
